// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Arsenal:wght@300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   GLOBAL
   ========================= */
.ck-page {
  min-height: 100vh;
  background: transparent !important; /* 👈 Isko change kiya hai */
  color: #fff;
  margin: 0;
  padding: 0;
  font-family: var(--font-body);
}

.ck-page * {
  box-sizing: border-box;
}


/* =========================
   HEADER
   ========================= */
.ck-header-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #000;
  z-index: 800;
  display: flex;
  align-items: center;
}

.ck-header-inner {
  width: 100%;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ck-header-logo {
  height: 56px;
  width: auto;
  object-fit: contain;
}

/* Hamburger */
.ck-hamburger {
  width: 40px;
  height: 32px;
  padding: 4px;
  border-radius: 10px;
  border: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  margin-top: 14px;
}

.ck-hamburger span {
  width: 100%;
  height: 2px;
  background: #d1d5db;
  border-radius: 999px;
}

.ck-hamburger-open span:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}

.ck-hamburger-open span:nth-child(2) {
  opacity: 0;
}

.ck-hamburger-open span:nth-child(3) {
  transform: translateY(-10px) rotate(-45deg);
}

/* Backdrop */
.ck-menu-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
}

/* =========================
   LAYOUT
   ========================= */
.ck-form-section {
  display: flex;
  justify-content: center;
  padding: 0;
}

.ck-form-layout {
  width: 100%;
  max-width: 1400px;
  flex-direction: column;
  margin: 0 auto;
  display: flex;
  gap: 210px;
  margin-top: 0;
  align-items: center;
  justify-content: center;
}

.ck-hero {
  width: 100%;
  max-width: 550px;
  text-align: left;
}

.ck-hero-text {
  font-family: arsenal;
  font-weight: 300;
  line-height: 1.4;
  padding-left: 12px;
  text-align: center;
  margin-bottom: 0;
}

.ck-tags-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 0;
}

.notPayble {
  margin-top: 16px !important;
  font-size: 14px !important;
  color: #f59255 !important;
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  font-weight: 500;
}

.ck-tags-row {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 14px;
}

.ck-hero-sub {
  font-family: Arsenal;
  font-weight: 300;
  line-height: 1.4;
  text-align: center;
  margin-bottom: 0;
}

.ck-delivery-text-left {
  text-align: center;
  font-size: clamp(14px, 2vw, 15px);
  line-height: 1.5;
  opacity: 0.8;
}

/* =========================
   FORM PANEL
   ========================= */
.ck-form-panel {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  margin-top: -40px;
}

.ck-form-panel>.ck-form-heading {
  font-size: 26px;
  font-weight: 300;
  margin-bottom: 24px;
  text-align: left;
}

.ck-form-heading {
  font-family: var(--font-display);
  font-size: clamp(24px, 4vw, 28px);  
  font-weight: 300;
  margin-bottom: 2rem;
  text-align: left;
  min-height: 48px;
  line-height: 48px;
  display: flex;
  align-items: center;
}

.ck-label {
  min-height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
}


/* ========================================================= */
/* SCROLLBAR STYLING - UPDATED: Ultra thin & No Arrows */
/* ========================================================= */
.ck-form-card,
.ck-form-slide {
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #f59255 transparent;
}

.ck-form-card {
  border: 2px solid #f59255;
  border-radius: 15px;
  overflow: auto;
  background: transparent;
  display: flex;
  flex-direction: column;
}

/* Chrome, Edge, Safari */
.ck-form-card::-webkit-scrollbar,
.ck-form-slide::-webkit-scrollbar {
  width: 2px !important;
  /* Ultra thin vertical */
  height: 2px !important;
  /* Ultra thin horizontal */
  background: transparent;
}

.ck-form-card::-webkit-scrollbar-thumb,
.ck-form-slide::-webkit-scrollbar-thumb {
  background: #f59255;
  border-radius: 4px;
}

.ck-form-card::-webkit-scrollbar-thumb:hover,
.ck-form-slide::-webkit-scrollbar-thumb:hover {
  background: #f59255;
}

.ck-form-card::-webkit-scrollbar-track,
.ck-form-slide::-webkit-scrollbar-track {
  background: transparent;
  /* or #000 */
}

/* Hide Arrows/Buttons */
.ck-form-card::-webkit-scrollbar-button,
.ck-form-slide::-webkit-scrollbar-button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}


/* PersonalizedReport.css (or OTP step css) */
.otp-title,
.otp-step-title,
.otp-wrap h1,
.otp-wrap h2 {
  width: 100% !important;
  display: block !important;
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
  min-height: auto !important;
  line-height: normal !important;
  margin-bottom: 2rem !important;
}

/* Slider area */
.scroll-area {
  flex: 0 0 auto;
}

.ck-form-slider {
  width: 100%;
  overflow: hidden;
}

.ck-form-track {
  display: flex;
  width: 100%;
}

.ck-form-slide {
  flex: 0 0 100%;
  overflow: auto;
  height: 30rem;
}

.ck-form-inner {
  width: 100%;
  padding: 1.5rem 1.2rem 1.2rem;
}

/* =========================
   OTP / INPUTS
   ========================= */
.ck-field-block {
  margin-bottom: 0.75rem;
}

.ck-label {
  font-size: 1.1rem;
  font-weight: 300;
  margin-bottom: 0.4rem;
}

.ck-inline-inputs {
  display: flex;
  gap: 12px;
  align-items: center;
}

.ck-input-flex {
  width: 100%;
  background: transparent;
  border: 1.5px solid #666;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  color: #fff;
  outline: none;
  height: 40px;
  flex: 1 1;
}

.ck-input-flex:focus {
  border-color: #f59255;
  box-shadow: 0 0 0 0.2rem rgba(255, 145, 77, 0.25);
}

.readonly-input {
  background: transparent;
  border-color: #2a2a2a;
  cursor: default;
}

.ck-pill {
  border-radius: 8px;
  border: 1.5px solid #666;
  background: transparent;
  font-size: 1rem;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  height: 40px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ck-pill:hover {
  border-color: #f59255;
}

.ck-pill:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* =========================
   FIXED NAV + FOOTER INSIDE CARD
   ========================= */
.ck-fixed-nav {
  background: #000;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.ck-prev-link,
.ck-next-link {
  font-size: 1rem;
  color: #f59255;
  cursor: pointer;
}

.ck-next-link.disabled {
  color: #666;
  cursor: not-allowed;
}

.ck-prev-link:hover,
.ck-next-link:hover {
  color: #f59255;
}

.ck-form-footer {
  display: flex;
  width: 100%;
  background: #000;
  border-top: 2px solid #f59255;
}

/* IMPORTANT: no borders here (borders cause corner cut) */
.ck-price-pill {
  flex: 0 0 50%;
  width: 50%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;

  background: transparent;
  color: #fff;
  padding: 0;
  border-right: 2px solid #f59255;
}

.ck-proceed-btn {
  flex: 0 0 50%;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 21px !important;
  border: none;
  background: grey;
  height: 48px;
  padding: 0;
}

.ck-proceed-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}


/* ✅ FULL ORANGE ONLY WHEN READY */
.ck-proceed-btn.ck-proceed-btn-ready {
  background: #f59255;
  color: #000;
  opacity: 1;
}

/* =========================
   FAQ
   ========================= */
.ck-faq-section {
  padding: 0;
  text-align: center;
}

.ck-faq-title {
  font-family: var(--font-display);
  font-size: 28px;
  font-weight: 300;
  margin-bottom: 0;
}

.ck-faq-list {
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.ck-faq-item {
  border: 2px solid #3a3a3a;
  border-bottom: 1px solid #3a3a3a;
  padding: 12px 16px;
  font-size: 18px;
  cursor: pointer;
  text-align: left;
}

@media (max-width: 500px) {
  .ck-price-pill {
    font-size: 21px;
  }

  .ck-proceed-btn {
    font-size: 20px;
  }
}

.ck-faq-item:hover {
  border-color: #f59255;
}

.ck-faq-item-active {
  border-color: #f59255;
}

.faq-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.faq-toggle {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.faq-arrow {
  font-size: 18px;
  display: inline-block;
}

.faq-toggle.open .faq-arrow {
  transform: rotate(90deg);
}

.faq-question {
  font-size: 20px;
}

.faq-answer {
  padding-left: 15px;
  font-size: 18px;
  line-height: 1.6;
  opacity: 0.85;
  margin-top: 10px;
  word-break: break-word;
}

.ck-faq-footer {
  font-size: 16px;
  opacity: 0.85;
  margin-top: 0;
}

/* OTP heading centered */
.otp-title {
  text-align: center !important;
  font-size: 28px;
  font-weight: 300;
}

/* Verified button full orange when verified */
.otp-verified-btn {
  border: 1.5px solid #666;
  background: transparent;
  color: #fff;
  border-radius: 12px;
  height: 44px;
  padding: 0 18px;
}

.otp-verified-btn.is-verified {
  background: #f59255 !important;
  border-color: #f59255 !important;
  color: #0b0b0b !important;
  font-weight: 800;
}

/* Proceed full orange */
.otp-proceed-btn {
  width: 100%;
  height: 52px;
  border-radius: 0;
  border: none;
  background: #f59255 !important;
  color: #0b0b0b !important;
  font-weight: 800;
}

.otp-proceed-btn:disabled {
  opacity: 0.55;
  /* keeps orange but shows disabled */
  cursor: not-allowed;
}

/* =========================
   RESPONSIVE
   ========================= */
@media (max-width: 1024px) {
  .ck-form-layout {
    flex-direction: column;
    gap: 145px;
    align-items: center;
  }

  .ck-form-panel {
    max-width: 650px;
    margin-top: 0;
  }

  .ck-form-panel>.ck-form-heading {
    text-align: center;
  }
}

@media (max-width: 768px) {
  .ck-form-section {
    padding: 0 20px 60px;
  }

  .ck-inline-inputs {
    flex-wrap: wrap;
  }

  .ck-form-inner {
    padding: 1.2rem;
  }
}

@media (max-width: 480px) {
  .ck-form-section {
    padding: 0 16px 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/PersonalizedReport.css"],"names":[],"mappings":"AAEA;;8BAE8B;AAC9B;EACE,iBAAiB;EACjB,kCAAkC,EAAE,4BAA4B;EAChE,WAAW;EACX,SAAS;EACT,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;;8BAE8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,aAAa;AACb;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;;8BAE8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;AACd;;AAEA;;8BAE8B;AAC9B;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;;AAGA,8DAA8D;AAC9D,wDAAwD;AACxD,8DAA8D;AAC9D;;EAEE,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;;EAEE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;AACd;;AAEA,wBAAwB;AACxB;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;;AAGA,6CAA6C;AAC7C;;;;EAIE,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;8BAE8B;AAC9B;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,aAAa;EACb,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8BAE8B;AAC9B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;;EAEf,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;;8BAE8B;AAC9B;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;EACxB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;8BAE8B;AAC9B;EACE;IACE,sBAAsB;IACtB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Arsenal:wght@300;400;500&display=swap\");\n\n/* =========================\n   GLOBAL\n   ========================= */\n.ck-page {\n  min-height: 100vh;\n  background: transparent !important; /* 👈 Isko change kiya hai */\n  color: #fff;\n  margin: 0;\n  padding: 0;\n  font-family: var(--font-body);\n}\n\n.ck-page * {\n  box-sizing: border-box;\n}\n\n\n/* =========================\n   HEADER\n   ========================= */\n.ck-header-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 60px;\n  background: #000;\n  z-index: 800;\n  display: flex;\n  align-items: center;\n}\n\n.ck-header-inner {\n  width: 100%;\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ck-header-logo {\n  height: 56px;\n  width: auto;\n  object-fit: contain;\n}\n\n/* Hamburger */\n.ck-hamburger {\n  width: 40px;\n  height: 32px;\n  padding: 4px;\n  border-radius: 10px;\n  border: none;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  cursor: pointer;\n  margin-top: 14px;\n}\n\n.ck-hamburger span {\n  width: 100%;\n  height: 2px;\n  background: #d1d5db;\n  border-radius: 999px;\n}\n\n.ck-hamburger-open span:nth-child(1) {\n  transform: translateY(10px) rotate(45deg);\n}\n\n.ck-hamburger-open span:nth-child(2) {\n  opacity: 0;\n}\n\n.ck-hamburger-open span:nth-child(3) {\n  transform: translateY(-10px) rotate(-45deg);\n}\n\n/* Backdrop */\n.ck-menu-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n}\n\n/* =========================\n   LAYOUT\n   ========================= */\n.ck-form-section {\n  display: flex;\n  justify-content: center;\n  padding: 0;\n}\n\n.ck-form-layout {\n  width: 100%;\n  max-width: 1400px;\n  flex-direction: column;\n  margin: 0 auto;\n  display: flex;\n  gap: 210px;\n  margin-top: 0;\n  align-items: center;\n  justify-content: center;\n}\n\n.ck-hero {\n  width: 100%;\n  max-width: 550px;\n  text-align: left;\n}\n\n.ck-hero-text {\n  font-family: arsenal;\n  font-weight: 300;\n  line-height: 1.4;\n  padding-left: 12px;\n  text-align: center;\n  margin-bottom: 0;\n}\n\n.ck-tags-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 0;\n}\n\n.notPayble {\n  margin-top: 16px !important;\n  font-size: 14px !important;\n  color: #f59255 !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  font-weight: 500;\n}\n\n.ck-tags-row {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n.ck-hero-sub {\n  font-family: Arsenal;\n  font-weight: 300;\n  line-height: 1.4;\n  text-align: center;\n  margin-bottom: 0;\n}\n\n.ck-delivery-text-left {\n  text-align: center;\n  font-size: clamp(14px, 2vw, 15px);\n  line-height: 1.5;\n  opacity: 0.8;\n}\n\n/* =========================\n   FORM PANEL\n   ========================= */\n.ck-form-panel {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  margin-top: -40px;\n}\n\n.ck-form-panel>.ck-form-heading {\n  font-size: 26px;\n  font-weight: 300;\n  margin-bottom: 24px;\n  text-align: left;\n}\n\n.ck-form-heading {\n  font-family: var(--font-display);\n  font-size: clamp(24px, 4vw, 28px);  \n  font-weight: 300;\n  margin-bottom: 2rem;\n  text-align: left;\n  min-height: 48px;\n  line-height: 48px;\n  display: flex;\n  align-items: center;\n}\n\n.ck-label {\n  min-height: 32px;\n  line-height: 32px;\n  display: flex;\n  align-items: center;\n}\n\n\n/* ========================================================= */\n/* SCROLLBAR STYLING - UPDATED: Ultra thin & No Arrows */\n/* ========================================================= */\n.ck-form-card,\n.ck-form-slide {\n  /* Firefox */\n  scrollbar-width: thin;\n  scrollbar-color: #f59255 transparent;\n}\n\n.ck-form-card {\n  border: 2px solid #f59255;\n  border-radius: 15px;\n  overflow: auto;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Chrome, Edge, Safari */\n.ck-form-card::-webkit-scrollbar,\n.ck-form-slide::-webkit-scrollbar {\n  width: 2px !important;\n  /* Ultra thin vertical */\n  height: 2px !important;\n  /* Ultra thin horizontal */\n  background: transparent;\n}\n\n.ck-form-card::-webkit-scrollbar-thumb,\n.ck-form-slide::-webkit-scrollbar-thumb {\n  background: #f59255;\n  border-radius: 4px;\n}\n\n.ck-form-card::-webkit-scrollbar-thumb:hover,\n.ck-form-slide::-webkit-scrollbar-thumb:hover {\n  background: #f59255;\n}\n\n.ck-form-card::-webkit-scrollbar-track,\n.ck-form-slide::-webkit-scrollbar-track {\n  background: transparent;\n  /* or #000 */\n}\n\n/* Hide Arrows/Buttons */\n.ck-form-card::-webkit-scrollbar-button,\n.ck-form-slide::-webkit-scrollbar-button {\n  display: none !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n\n/* PersonalizedReport.css (or OTP step css) */\n.otp-title,\n.otp-step-title,\n.otp-wrap h1,\n.otp-wrap h2 {\n  width: 100% !important;\n  display: block !important;\n  text-align: center !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n  min-height: auto !important;\n  line-height: normal !important;\n  margin-bottom: 2rem !important;\n}\n\n/* Slider area */\n.scroll-area {\n  flex: 0 0 auto;\n}\n\n.ck-form-slider {\n  width: 100%;\n  overflow: hidden;\n}\n\n.ck-form-track {\n  display: flex;\n  width: 100%;\n}\n\n.ck-form-slide {\n  flex: 0 0 100%;\n  overflow: auto;\n  height: 30rem;\n}\n\n.ck-form-inner {\n  width: 100%;\n  padding: 1.5rem 1.2rem 1.2rem;\n}\n\n/* =========================\n   OTP / INPUTS\n   ========================= */\n.ck-field-block {\n  margin-bottom: 0.75rem;\n}\n\n.ck-label {\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin-bottom: 0.4rem;\n}\n\n.ck-inline-inputs {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.ck-input-flex {\n  width: 100%;\n  background: transparent;\n  border: 1.5px solid #666;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  color: #fff;\n  outline: none;\n  height: 40px;\n  flex: 1;\n}\n\n.ck-input-flex:focus {\n  border-color: #f59255;\n  box-shadow: 0 0 0 0.2rem rgba(255, 145, 77, 0.25);\n}\n\n.readonly-input {\n  background: transparent;\n  border-color: #2a2a2a;\n  cursor: default;\n}\n\n.ck-pill {\n  border-radius: 8px;\n  border: 1.5px solid #666;\n  background: transparent;\n  font-size: 1rem;\n  color: #fff;\n  cursor: pointer;\n  white-space: nowrap;\n  height: 40px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ck-pill:hover {\n  border-color: #f59255;\n}\n\n.ck-pill:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* =========================\n   FIXED NAV + FOOTER INSIDE CARD\n   ========================= */\n.ck-fixed-nav {\n  background: #000;\n  padding: 8px 16px;\n  display: flex;\n  justify-content: space-between;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.ck-prev-link,\n.ck-next-link {\n  font-size: 1rem;\n  color: #f59255;\n  cursor: pointer;\n}\n\n.ck-next-link.disabled {\n  color: #666;\n  cursor: not-allowed;\n}\n\n.ck-prev-link:hover,\n.ck-next-link:hover {\n  color: #f59255;\n}\n\n.ck-form-footer {\n  display: flex;\n  width: 100%;\n  background: #000;\n  border-top: 2px solid #f59255;\n}\n\n/* IMPORTANT: no borders here (borders cause corner cut) */\n.ck-price-pill {\n  flex: 0 0 50%;\n  width: 50%;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 21px;\n\n  background: transparent;\n  color: #fff;\n  padding: 0;\n  border-right: 2px solid #f59255;\n}\n\n.ck-proceed-btn {\n  flex: 0 0 50%;\n  width: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 21px !important;\n  border: none;\n  background: grey;\n  height: 48px;\n  padding: 0;\n}\n\n.ck-proceed-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n\n/* ✅ FULL ORANGE ONLY WHEN READY */\n.ck-proceed-btn.ck-proceed-btn-ready {\n  background: #f59255;\n  color: #000;\n  opacity: 1;\n}\n\n/* =========================\n   FAQ\n   ========================= */\n.ck-faq-section {\n  padding: 0;\n  text-align: center;\n}\n\n.ck-faq-title {\n  font-family: var(--font-display);\n  font-size: 28px;\n  font-weight: 300;\n  margin-bottom: 0;\n}\n\n.ck-faq-list {\n  max-width: 400px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.ck-faq-item {\n  border: 2px solid #3a3a3a;\n  border-bottom: 1px solid #3a3a3a;\n  padding: 12px 16px;\n  font-size: 18px;\n  cursor: pointer;\n  text-align: left;\n}\n\n@media (max-width: 500px) {\n  .ck-price-pill {\n    font-size: 21px;\n  }\n\n  .ck-proceed-btn {\n    font-size: 20px;\n  }\n}\n\n.ck-faq-item:hover {\n  border-color: #f59255;\n}\n\n.ck-faq-item-active {\n  border-color: #f59255;\n}\n\n.faq-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.faq-toggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.faq-arrow {\n  font-size: 18px;\n  display: inline-block;\n}\n\n.faq-toggle.open .faq-arrow {\n  transform: rotate(90deg);\n}\n\n.faq-question {\n  font-size: 20px;\n}\n\n.faq-answer {\n  padding-left: 15px;\n  font-size: 18px;\n  line-height: 1.6;\n  opacity: 0.85;\n  margin-top: 10px;\n  word-break: break-word;\n}\n\n.ck-faq-footer {\n  font-size: 16px;\n  opacity: 0.85;\n  margin-top: 0;\n}\n\n/* OTP heading centered */\n.otp-title {\n  text-align: center !important;\n  font-size: 28px;\n  font-weight: 300;\n}\n\n/* Verified button full orange when verified */\n.otp-verified-btn {\n  border: 1.5px solid #666;\n  background: transparent;\n  color: #fff;\n  border-radius: 12px;\n  height: 44px;\n  padding: 0 18px;\n}\n\n.otp-verified-btn.is-verified {\n  background: #f59255 !important;\n  border-color: #f59255 !important;\n  color: #0b0b0b !important;\n  font-weight: 800;\n}\n\n/* Proceed full orange */\n.otp-proceed-btn {\n  width: 100%;\n  height: 52px;\n  border-radius: 0;\n  border: none;\n  background: #f59255 !important;\n  color: #0b0b0b !important;\n  font-weight: 800;\n}\n\n.otp-proceed-btn:disabled {\n  opacity: 0.55;\n  /* keeps orange but shows disabled */\n  cursor: not-allowed;\n}\n\n/* =========================\n   RESPONSIVE\n   ========================= */\n@media (max-width: 1024px) {\n  .ck-form-layout {\n    flex-direction: column;\n    gap: 145px;\n    align-items: center;\n  }\n\n  .ck-form-panel {\n    max-width: 650px;\n    margin-top: 0;\n  }\n\n  .ck-form-panel>.ck-form-heading {\n    text-align: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .ck-form-section {\n    padding: 0 20px 60px;\n  }\n\n  .ck-inline-inputs {\n    flex-wrap: wrap;\n  }\n\n  .ck-form-inner {\n    padding: 1.2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .ck-form-section {\n    padding: 0 16px 50px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
